// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"bc587528","638":"bc587528","662":"bc587528","711":"bc587528","830":"b07525d0"}[chunkId] + ".chunk.css";
};